import {
  CoursesChangesActions,
  ECoursesChangesActions,
} from '@myStore/courses-changes/courses-changes.actions';
import {
  ICoursesChangesState,
  initialCoursesChangesState,
} from '@myStore/courses-changes/courses-changes.state';

export const coursesChangesReducers = (
  state = initialCoursesChangesState,
  actions: CoursesChangesActions
): ICoursesChangesState => {
  switch (actions.type) {
    case ECoursesChangesActions.SendCreateCourseRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesChangesActions.SendCreateCourseSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case ECoursesChangesActions.SendCreateCourseFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ECoursesChangesActions.ClearCreateCourseErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case ECoursesChangesActions.SendUpdateCourseRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesChangesActions.SendUpdateCourseSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case ECoursesChangesActions.SendUpdateCourseFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ECoursesChangesActions.ClearUpdateCourseErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case ECoursesChangesActions.DeleteCourseRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesChangesActions.DeleteCourseSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case ECoursesChangesActions.DeleteCourseFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ECoursesChangesActions.ClearDeleteCourseErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case ECoursesChangesActions.SendDeactivateCourseRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesChangesActions.SendDeactivateCourseSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case ECoursesChangesActions.SendDeactivateCourseFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ECoursesChangesActions.ClearDeactivateCourseErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case ECoursesChangesActions.ActivateCourseRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesChangesActions.ActivateCourseSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case ECoursesChangesActions.ActivateCourseFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ECoursesChangesActions.ClearActivateCourseErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    default:
      return state;
  }
};
